import { getMessages, getWorkspacesMessagesAmount } from '../../apiServices/messageApi';

// ── API helpers (moved from old navigationBar/navigationBarUtils.js) ──

export async function getMessagesForCurrentUserGroup() {
  try {
    const response = await getMessages();
    return response.response.Items;
  } catch {
    console.warn('Failed to fetch messages');
    return false;
  }
}

export async function getAllMessages() {
  try {
    const response = await getWorkspacesMessagesAmount();
    return response.response.Items;
  } catch {
    console.warn('Failed to fetch messages');
    return false;
  }
}

// ── Message processing (moved from old navigationBar/messages/MessagesSubnavItemsUtilityFunctions.js) ──

interface RawMessage {
  project: { S: string };
  project_title: { S: string };
  statustype?: { S: string };
  read?: { N: string };
  created: { S: string };
}

interface ProjectMessageSummary {
  title: string;
  projectId: string;
  taskMsgCount: number;
  unreadTaskMsgsCount: number;
  msgCount: number;
  unreadMessagesCount: number;
  latestMessage: string;
}

function countMessages(messagesList: RawMessage[], id: string, type: string, readFilter: 'read' | 'unread') {
  return messagesList.filter((m) => {
    if (m.project.S !== id) return false;
    if (m.statustype?.S !== type) return false;
    if (readFilter === 'unread') return m.read?.N === '0';
    return !(m.read?.N === '0');
  }).length;
}

export function processMessagesListData(messagesList: RawMessage[]): ProjectMessageSummary[] {
  // Get unique project IDs
  const projectIds = [...new Set(messagesList.map((m) => m.project.S))];

  const projects = projectIds.map((id) => {
    const firstMsg = messagesList.find((m) => m.project.S === id)!;
    let latestMessage = '0';
    messagesList.forEach((m) => {
      if (m.project.S === id && m.created.S > latestMessage) {
        latestMessage = m.created.S;
      }
    });

    return {
      title: firstMsg.project_title.S,
      projectId: id,
      taskMsgCount: countMessages(messagesList, id, 'task', 'read'),
      unreadTaskMsgsCount: countMessages(messagesList, id, 'task', 'unread'),
      msgCount: countMessages(messagesList, id, 'msg', 'read'),
      unreadMessagesCount: countMessages(messagesList, id, 'msg', 'unread'),
      latestMessage,
    };
  });

  return projects.sort((a, b) => b.latestMessage.localeCompare(a.latestMessage));
}
